/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:02 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var ContentSystemBaseModel = require("content-models/system/ContentSystemBaseModel");
    var ContentSystemUtilities = require("content-utils/ContentSystemUtilities");
    var validationConfig = require("content-config/contentSystemValidationConfig.json");
    var LocaleResolver = require("i18n/localeResolver");
    var systemMessageConfig = require("content-config/systemMessageConfig.json");
    var CONST = require("const");

    var KEYS = {
        EVENT_ID: "messageEventId",
        TIMER: "timer",
        CONTEXTS: "contexts",
        SKILL: "SKILL",
        CONTEXTS_SKILL: "contexts.SKILL"
    };

    var URL_TYPE = {
        GET: "GET",
        UPDATE_ACCOUNT: "UPDATE_ACCOUNT",
        UPDATE_SKILL: "UPDATE_SKILL",
        DELETE: "DELETE"
    };

    var STATUS = {
        ENABLED: "enabled",
        MULTIPLE: "multiple",
        DISABLED: "disabled"
    };

    var ContentSystemModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemModel = ContentSystemBaseModel.extend({
            resource: ApiResources.AccountConfig.SystemMessages,
            name: "ContentSystemModel",
            type: null,
            defaults: {
                id: null, //new model id must be null so model.isNew() wil work
                enabled: true,
                messageEventId: "",
                data: []

            },
            url: function(){
                var url = ContentSystemBaseModel.prototype.url.call(this);
                switch(this.type) {
                    case URL_TYPE.UPDATE_SKILL:
                    case URL_TYPE.DELETE:
                        return url += "&context_type=SKILL&context_id=" + this.getSkillId();
                    case URL_TYPE.UPDATE_ACCOUNT:
                        return url;
                    default:
                        return url;
                }
            },
            save: function(attributes, options, isSkillContext) {
                attributes = attributes || {};
                options = options || {};
                if(isSkillContext) {
                    this._setUrlType(URL_TYPE.UPDATE_SKILL);
                } else {
                    this._setUrlType(URL_TYPE.UPDATE_ACCOUNT);
                }
                return ContentSystemBaseModel.prototype.save.call(this, attributes, options);
            },
            destroy: function(options) {
                options = options || {};
                this._setUrlType(URL_TYPE.DELETE);
                return ContentSystemBaseModel.prototype.destroy.call(this, options);
            },
            validateSaveEnabled:function (lang, languages) {
                this._cleanLanguagesWithErrors(languages);
                var isContentValid = this.validateContentMessage(lang);
                var tooltip = !isContentValid ? this.saveContentMessageLengthTooltip() : "";
                return {
                    isSaveValid: isContentValid,
                    tooltip: tooltip
                };
            },
            _cleanLanguagesWithErrors: function(languages) {
                var languagesToRemove = [];
                _.each(this.languagesWithErrors, _.bind(function(lang, index){
                    var ind = languages.indexOf(lang);
                    if (ind < 0) {
                        languagesToRemove.push(lang);
                    }
                }, this));
                this.languagesWithErrors = _.difference(this.languagesWithErrors, languagesToRemove);
            },
            validateContentMessage: function(selectedLanguage) {
                var msg = this.getContentMessage(selectedLanguage);
                if (msg.length <= systemMessageConfig.maxMessageSize.liveChat) {
                    this.languagesWithErrors = _.reject(this.languagesWithErrors, function(lang) {
                        return lang === selectedLanguage;
                    });
                }
                else {
                    this.languagesWithErrors = _.union(this.languagesWithErrors ,[selectedLanguage]);
                }
                return _.isEmpty(this.languagesWithErrors);
            },
            initLanguagesWithErrors: function() {
                this.languagesWithErrors = [];
            },
            saveContentMessageLengthTooltip: function() {
                return ContentSystemUtilities.saveContentMessageLengthTooltip();
            },
            initialize: function(options){
                ContentSystemBaseModel.prototype.initialize.call(this, options);
            },
            hasContent: function(lang){
                return this.hasContentMessage(lang);
            },
            getLanguagesWithErrors: function() {
                return this.languagesWithErrors;
            },
            hasTitleField: function() {
                return false;
            },
            getAttrs: function () {
                return this.get(ContentSystemBaseModel.KEYS.ATTRIBUTES);
            },
            setValidations: function(){
                ContentSystemBaseModel.prototype.setValidations.call(this);

                //todo if there is more then timer create this autoamtically for all array attributes
                //do it on validation utilities
                if(this.isNotEmptyModel()) {
                    if (this.isOnHoldMessage()) { //set the validation for the timer according to its index in the array
                        this.validation[this.getTimerKey()] = this.getValidationConfig().validationForArrays.timer.value;
                    }
                }
            },
            getValidationConfig: function(){
               return validationConfig;
            },
            getTimerAttrIndex: function () {
                //todo if there is nore then timer create this autoamtically for all array attributes
                if (_.isUndefined(this.timerAttrIndex)) { //init timer index only once
                    this.timerAttrIndex  = -1;
                    if (this.isOnHoldMessage()) {
                        var attrs = this.getAttrs();
                        this.timerAttrIndex  = attrs.length - 1;
                        for (; this.timerAttrIndex  > -1; this.timerAttrIndex --) {
                            if (attrs[this.timerAttrIndex ][ContentSystemBaseModel.KEYS.ATTR_NAME] === KEYS.TIMER) {
                                break;
                            }
                        }
                        if (this.timerAttrIndex === -1) {
                            LEContent.logger.graph({name: "content:ContentSystemModel:timerIndex:error" });
                            LEContent.logger.error("We should have a timer index but its not found","ContentSystemModel:getTimerAttrIndex");
                        }

                    }
                }
                return this.timerAttrIndex;
            },
            getTimerKey: function(){
                var index = this.getTimerAttrIndex();
                return ContentSystemBaseModel.KEYS.ATTRIBUTES + "." + index +"." + ContentSystemBaseModel.KEYS.ATTR_VALUE;
            },
            setTimer: function(time){
                this.set(this.getTimerKey() ,time);
            },
            getTimer: function(){
                return this.get(this.getTimerKey());
            },
            getEventId: function (){
                return this.get(KEYS.EVENT_ID);
            },
            getName: function(){
                var eventNameKey =  'LEContent.content.system.event.' + this.getEventId().toString() + ".name";
                return this._getTranslatedName(eventNameKey);
            },
            getNameForEditPage: function(){
                var eventNameKey =  'LEContent.content.system.edit.event.' + this.getEventId().toString() + ".name";
                return this._getTranslatedName(eventNameKey);
            },
            _getTranslatedName: function(eventNameKey){
                //get name in this order: Interface language, Default account language, en-US
                var chosenLocale = _.find([LocaleResolver.getLocale(),LE.siteSettings.supportedLanguageSettings.getDefaultLanguage()],function(locale){
                    return  LE.translator.hasTranslationKey(locale, eventNameKey);
                },this);

                if (!chosenLocale) {
                    chosenLocale = CONST.LANGUAGE["en-US"];
                }

                return LE.translator.translate(eventNameKey,chosenLocale);
            },
            getSkills: function(){
                return this.get(KEYS.CONTEXTS_SKILL);
            },
            setSkills: function(skillsArray){
                this.set(KEYS.CONTEXTS_SKILL, skillsArray);
            },
            //jasonized settings
            isOnHoldMessage: function(){
                if(this.isNotEmptyModel()) {
                    return  ContentSystemUtilities.isTimerAllowed(this.getEventId());
                }
                return false;
            },
            isEnabledEditable: function(){
                if(this.isNotEmptyModel()) {
                    return  ContentSystemUtilities.isEnabledEditable(this.getEventId());
                }
                return false;
            },
            getStatusState: function() {
                var status = this.get(ContentSystemBaseModel.KEYS.ENABLED);
                _.find(this.get(KEYS.CONTEXTS_SKILL), function(skill) {
                    if(status !== skill.enabled) {
                        status = STATUS.MULTIPLE;
                        return true;
                    }
                }, this);
                if(status === STATUS.MULTIPLE) {
                    return status;
                }
                return status ? STATUS.ENABLED : STATUS.DISABLED;
            },
            getAllowedMacros: function(){
                if(this.isNotEmptyModel()) {
                    return ContentSystemUtilities.macros(this.getEventId());
                }
                return false;
            },
            getAllSystemMacros: function(){
                return ContentSystemUtilities.allAvailableMacroValues();
            },

            saveEmptyTooltip: function(){
                return ContentSystemUtilities.saveEmptyTooltip();
            },
            saveNoChangesTooltip: function () {
                return ContentSystemUtilities.saveNoChangesTooltip();
            },
            getHeaderTexts: function() {
                return ContentSystemUtilities.getHeaderTexts(this.isOnHoldMessage());
            },
            cleanData: function() {
                //first remove empty elements they can not be saved to the server
                _.each(this.getData(),function(content){
                    //if content was deleted send isDefault Flag - server will delete the DB data and the next fetch will bring empty/ or defaults if they exists.
                    // this will delete it in the DB
                    if (!this.hasContentMessage(content.lang) ) {
                        this.set(this._getIsDefaultKey(content.lang),true);
                    }
                },this);
            },
            _setUrlType: function(type){
                this.type = type;
            },
            setSkillId: function(skillId){
                this.skillId = skillId;
            },
            getSkillId: function(){
                return this.skillId;
            },
            setSelectedLanguage: function(selectedLanguage){
                this.selectedLanguage = selectedLanguage;   //todo noam/Ivan CR check why not save on pageModel
            },
            getSelectedLanguage: function(){
                return this.selectedLanguage;
            },
            isNotEmptyModel: function() {
                return !!this.id;
            },
            parse: function(response, options) {
                if (response[KEYS.CONTEXTS]) {
                    response[KEYS.CONTEXTS][KEYS.SKILL] = response[KEYS.CONTEXTS][KEYS.SKILL] || [];
                }
                return ContentSystemBaseModel.prototype.parse.call(this, response, options);
            }
        });
    });

    ContentSystemModel.STATUS = STATUS;

    return ContentSystemModel;
});
